// extracted by mini-css-extract-plugin
export default {"container":"scoreDistribution_container__NKqCi","row":"scoreDistribution_row__vBciQ","chart":"scoreDistribution_chart__U35aH","table":"scoreDistribution_table__m1prt"};